import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ModalNavigationService } from '../../services/gui/modal/modal-navigation.service';
import { ModalNavigationComponent } from '../../services/gui/modal/modal-navigation-component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ListColumn } from '../../services/global/global-interfaces';
import { isColumnMatch } from '../../services/global/global-methods';

@Component({
  selector: 'sb-comp-column-option',
  templateUrl: './column-option.component.html',
  styleUrl: './column-option.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnOptionComponent implements OnInit, ModalNavigationComponent {
  protected readonly modalNavigation = inject(ModalNavigationService);
  isInModalContext: boolean;

  columns: ListColumn[] = [];
  selectedColumns: ListColumn[] = [];
  defaultColumns: ListColumn[] = [];
  columnSearch: string = '';

  ngOnInit(): void {
    if (this.isInModalContext) {
      const columns = this.modalNavigation.getCurrentNavigation().data.columns;
      const selectedColumns = this.modalNavigation.getCurrentNavigation().data.selectedColumns;
      this.defaultColumns = this.modalNavigation.getCurrentNavigation().data.defaultColumns;
      if (
        !columns ||
        !selectedColumns ||
        !this.defaultColumns ||
        !Array.isArray(columns) ||
        !Array.isArray(selectedColumns) ||
        !Array.isArray(this.defaultColumns)
      ) {
        throw new Error('No items provided at column option component');
      }
      this.columns = [...columns];
      this.selectedColumns = [...selectedColumns];
    }
  }

  addToSelectedColumns(column: ListColumn) {
    column.selected = true;
    this.selectedColumns.push(column);
  }

  removeFromSelectedColumns(searchColumn: ListColumn, index: number) {
    const sItem = this.columns.find(item => item.id === searchColumn.id);
    if (!sItem) {
      return;
    }
    sItem.selected = false;
    this.selectedColumns.splice(index, 1);
  }

  cancelColumnOptions() {
    this.modalNavigation.result(null);
  }

  submitColumnOptions() {
    this.modalNavigation.result(this.selectedColumns);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.selectedColumns, event.previousIndex, event.currentIndex);
  }

  getSortedColumns() {
    return [...this.columns].sort((a, b) => (a.title ?? a.id?.toString() ?? '').localeCompare(b.title ?? b.id?.toString() ?? ''));
  }

  columnsSelectNone() {
    this.columns.forEach(column => (column.selected = false));
    this.selectedColumns = [];
  }

  columnsRestoreDefault() {
    this.columnsSelectNone();

    for (const def of this.defaultColumns) {
      if (def.selected) {
        const match = this.columns.find(col => isColumnMatch(col, def));

        if (match) {
          match.selected = true;
          this.selectedColumns.push(match);
        }
      }
    }
  }

  getColumnIcon(column: ListColumn) {
    switch (column.type) {
      case 'PROPERTY':
        return 'wrench';
      case 'DEVICE_ATTRIBUTE':
        return 'playerOnline';
      case 'LOCATION_ATTRIBUTE':
        return 'location';
      case 'COMPANY_ATTRIBUTE':
        return 'company';
      default:
        return 'questionmark';
    }
  }
}
